import { render, staticRenderFns } from "./QuestionRoute.vue?vue&type=template&id=76285f47&scoped=true&"
import script from "./QuestionRoute.vue?vue&type=script&lang=js&"
export * from "./QuestionRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76285f47",
  null
  
)

export default component.exports